// extracted by mini-css-extract-plugin
export default {"sticky":"v_bV","top":"v_bW","container":"v_b","notScrolled":"v_bX"};